import type { Tendencia } from "../types";

/** Direção da tendência — honesta com poucos dados, nunca punitiva. */
const MAPA: Record<Tendencia, { ico: string; txt: string }> = {
  subindo: { ico: "↗", txt: "subindo" },
  estavel: { ico: "→", txt: "estável" },
  caindo: { ico: "↘", txt: "oscilando" }, // tom suave: não é "piorando"
  poucos_dados: { ico: "·", txt: "poucos dados" },
};

export function TendenciaLabel({ tendencia }: { tendencia: Tendencia }) {
  const m = MAPA[tendencia];
  return (
    <span className="tend">
      <span aria-hidden>{m.ico}</span>
      {m.txt}
    </span>
  );
}
